import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';

interface curso {
  id: string,
  cantVentas: number,
  categoria: string,
  descripcion: string,
  duracion: number,
  empresaFoto: string,
  empresaId: string,
  empresaNombre: string,
  fechaCreacion: Date,
  foto: string,
  nivel:string
  instructorFoto: string,
  instructorId: string,
  instructorNombre: string,
  porcentajeDescuento: number,
  precioFinal: number,
  precioOriginal: number,
  publicado: boolean,
  titulo: string,
  resumen: string,
  valoracion: number,
}

interface empresa {
  categorias: string[],
  cantCursos: number,
  fechaCreacion: Date,
  foto: string,
  id: string,
  cantInstructores: number,
  nombre: string,
  publicado: boolean,
  descripcion: string,
  cantVentas: number,
  resumen: string,
}

interface instructor {
  categorias: string[],
  cantCursos: number,
  descripcion: string,
  fechaCreacion: Date,
  foto: string,
  id: string,
  empresaId: string,
  nombre: string,
  empresaNombre: string,
  publicado: boolean,
  cantVentas: number,
  resumen: string,
}

interface categoriaContada {
  categoria: string,
  cant: number,
}

@Component({
  selector: 'buscar-empresas',
  templateUrl: './buscar.component.html',
  styleUrls: ['./buscar.component.css']
})

export class BuscarComponent implements OnInit {

  tipoBusqueda?: string = 'cursos';
  textoBusqueda: string = "";
  loaded = 0;

  imgCurso: string = "assets/images/cursos/curso1.jpg"

  // Variables de categorias
  categorias: string[];
  categoriasContadas: categoriaContada[] = []
  seleccionCategorias: string[] = []

  // Variables Ordenar Por

  
  ordenar: any = {
    'cursos': ["Populares", "Mejor Valorados", "Menor Precio", "Más Recientes", "Más Antiguos", "A-Z", "Z-A"],
    'instructores': ["Populares", "Más Recientes", "Más Antiguos", "A-Z", "Z-A"],
    'empresas': ["Populares", "Más Recientes", "Más Antiguos", "A-Z", "Z-A"],
  };

  niveles: string[] = ['Básico','Intermedio','Avanzado']
  filtroNivel: string = "";

  seleccionOrden: string = this.ordenar['cursos'][0];

  // Variables para Mostrar
  cursos: curso[];
  empresas: empresa[];
  instructores: instructor[];

  filteredCursos: curso[];
  filteredEmpresas: empresa[];
  filteredInstructores: instructor[];

  constructor(
    private afs: AngularFirestore,
    private shared: RoutingVariablesService,
    private seo: SeoService
  ) { }

  async ngOnInit() {
    await this.cargarCategorias();
    await this.cargarCursos()
    await this.cargarInstructores()
    await this.cargarEmpresas()
    this.seo.generateTags({
      title: "Predyc - Explorador de Cursos para la Industria",
      image: "assets/images/logos/logo.svg",
      description: "Cursos en línea en categorías como mantenimiento, manofactura, confiabilidad, petróleo o gestión de proyectos"
    })
  }

  /// Chequeo de Variables

  cambioSeleccion(categoria) {
    let idx = this.seleccionCategorias.indexOf(categoria);
    // Esta Seleccionado
    if (idx > -1) {
      this.seleccionCategorias.splice(idx, 1);
    }
    /// Es una nueva Seleccion
    else {
      this.seleccionCategorias.push(categoria)
    }
    this.filtrar();
  }



  filtrar() {
    this.filteredInstructores = this.instructores;
    this.filteredEmpresas = this.empresas;
    this.filteredCursos = this.cursos;
    if (this.tipoBusqueda == "cursos") {
      this.filtrarCursos();
    }
    if (this.tipoBusqueda == "instructores") {
      this.filtrarInstructores();
    }
    if (this.tipoBusqueda == "empresas") {
      this.filtrarEmpresas();
    }
  }

  filtrarCursos() {
    if (this.seleccionCategorias.length > 0) {
      this.filteredCursos = this.filteredCursos.filter(x => this.seleccionCategorias.includes(x.categoria))
      if (this.filtroNivel != "") {
        console.log(this.filteredCursos)
        this.filteredCursos = this.filteredCursos.filter(x => x.nivel == this.filtroNivel)
      }
    } else {
      this.filteredCursos = this.cursos
      console.log(this.filtroNivel)
      if (this.filtroNivel != "") {
        this.filteredCursos = this.filteredCursos.filter(x => x.nivel == this.filtroNivel)
      }
    }
    this.searchCurso(this.textoBusqueda)
    // Aplicar Orden de Cursos ////
    if (this.seleccionOrden == this.ordenar['cursos'][0]) {
      this.SortCursoByVentas()
    }
    if (this.seleccionOrden == this.ordenar['cursos'][1]) {
      this.SortCursoByValoracion()
    }
    if (this.seleccionOrden == this.ordenar['cursos'][2]) {
      this.SortCursoByPrecio()
    }
    if (this.seleccionOrden == this.ordenar['cursos'][3]) {
      this.SortCursoByDateReciente()
    }
    if (this.seleccionOrden == this.ordenar['cursos'][4]) {
      this.SortCursoByDateAntiguos()
    }
    if (this.seleccionOrden == this.ordenar['cursos'][5]) {
      this.SortCursoByAZ()
    }
    if (this.seleccionOrden == this.ordenar['cursos'][6]) {
      this.SortCursoByZA()
    }
  }

  filtrarEmpresas() {
    if (this.seleccionCategorias.length > 0) {
      this.filteredEmpresas = this.filteredEmpresas.filter(x => this.seleccionCategorias.some(r => x.categorias.includes(r)))
    } else {
      this.filteredEmpresas = this.empresas;
    }
    this.searchEmpresas(this.textoBusqueda)
    // Aplicar Orden de Cursos ////
    if (this.seleccionOrden == this.ordenar['empresas'][0]) {
      this.SortEmpresasByVentas()
    }
    if (this.seleccionOrden == this.ordenar['empresas'][1]) {
      this.SortEmpresasByDateReciente()
    }
    if (this.seleccionOrden == this.ordenar['empresas'][2]) {
      this.SortEmpresasByDateAntiguos()
    }
    if (this.seleccionOrden == this.ordenar['empresas'][3]) {
      this.SortEmpresasByAZ()
    }
    if (this.seleccionOrden == this.ordenar['empresas'][4]) {
      this.SortEmpresasByZA()
    }
  }

  filtrarInstructores() {
    if (this.seleccionCategorias.length > 0) {
      this.filteredInstructores = this.filteredInstructores.filter(x => this.seleccionCategorias.some(r => x.categorias.includes(r)))
    } else {
      this.filteredInstructores = this.instructores
    }
    this.searchInstructores(this.textoBusqueda)
    // Aplicar Orden de Cursos ////
    if (this.seleccionOrden == this.ordenar['instructores'][0]) {
      this.SortInstructoresByVentas()
    }
    if (this.seleccionOrden == this.ordenar['instructores'][1]) {
      this.SortInstructoresByDateReciente()
    }
    if (this.seleccionOrden == this.ordenar['instructores'][2]) {
      this.SortInstructoresByDateAntiguos()
    }
    if (this.seleccionOrden == this.ordenar['instructores'][3]) {
      this.SortInstructoresByAZ()
    }
    if (this.seleccionOrden == this.ordenar['instructores'][4]) {
      this.SortInstructoresByZA()
    }
  }

  /////////////////////// Filtros de Cursos /////////////////////////////

  SortCursoByPrecio() {
    this.filteredCursos.sort((a, b) => a.precioFinal - b.precioFinal);
  }

  SortCursoByVentas() {
    this.filteredCursos.sort((a, b) => b.cantVentas - a.cantVentas);
  }

  SortCursoByValoracion() {
    this.filteredCursos.sort((a,b) => b.valoracion - a.valoracion)
  }

  SortCursoByAZ() {
    this.filteredCursos.sort((a, b) => a.titulo.localeCompare(b.titulo));
  }

  SortCursoByZA() {
    this.filteredCursos.sort((a, b) => b.titulo.localeCompare(a.titulo));
  }

  SortCursoByDateReciente() {
    this.filteredCursos.sort((a, b) => +b.fechaCreacion - +a.fechaCreacion);
  }

  SortCursoByDateAntiguos() {
    this.filteredCursos.sort((a, b) => +a.fechaCreacion - +b.fechaCreacion);
  }

  searchCurso(searchValue: any) {

    this.filteredCursos = this.filteredCursos.filter(t =>
      t.titulo.toLowerCase().includes(searchValue.toLowerCase()) ||
      // t.resumenCorto.toLowerCase().includes(searchValue.toLowerCase()) ||
      t.instructorNombre.toLowerCase().includes(searchValue.toLowerCase()) ||
      t.empresaNombre.toLowerCase().includes(searchValue.toLowerCase())
    );

  }


  //////////////////////////////////////// Filtros de Instructores ///////////////////////////////////

  SortInstructoresByVentas() {
    this.filteredInstructores.sort((a, b) => b.cantVentas - a.cantVentas);
  }

  SortInstructoresByAZ() {
    this.filteredInstructores.sort((a, b) => a.nombre.localeCompare(b.nombre));
  }

  SortInstructoresByZA() {
    this.filteredInstructores.sort((a, b) => b.nombre.localeCompare(a.nombre));
  }

  SortInstructoresByDateReciente() {
    this.filteredInstructores.sort((a, b) => +b.fechaCreacion - +a.fechaCreacion);
  }

  SortInstructoresByDateAntiguos() {
    this.filteredInstructores.sort((a, b) => +a.fechaCreacion - +b.fechaCreacion);
  }

  searchInstructores(searchValue: any) {
    this.filteredInstructores = this.filteredInstructores.filter(t => t.nombre.toLowerCase().includes(searchValue.toLowerCase()));
  }

  ///////////////////////////////////////// Empresas ///////////////////////////////////////////////////////////////

  SortEmpresasByVentas() {
    this.filteredEmpresas.sort((a, b) => b.cantVentas - a.cantVentas);
  }

  SortEmpresasByAZ() {
    this.filteredEmpresas.sort((a, b) => a.nombre.localeCompare(b.nombre));
  }

  SortEmpresasByZA() {
    this.filteredEmpresas.sort((a, b) => b.nombre.localeCompare(a.nombre));
  }

  SortEmpresasByDateReciente() {
    this.filteredEmpresas.sort((a, b) => +b.fechaCreacion - +a.fechaCreacion);
  }

  SortEmpresasByDateAntiguos() {
    this.filteredEmpresas.sort((a, b) => +a.fechaCreacion - +b.fechaCreacion);
  }

  searchEmpresas(searchValue: any) {
    this.filteredEmpresas = this.filteredEmpresas.filter(t => t.nombre.toLowerCase().includes(searchValue.toLowerCase()));
  }

  // Cargas de informacion //////////////////////////////////////////////////

  async cargarCursos() {
    this.afs.doc("global/indiceCursos").get().subscribe(async snap => {
      const cursos = snap.data();
      let arr = []
      Object.keys(cursos).map(function (key) {
        arr.push(cursos[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        const duracion = arr[index].duracion
        const curso: curso = {
          id: arr[index].id,
          cantVentas: arr[index].cantVentas,
          categoria: arr[index].categoria,
          descripcion: arr[index].descripcion,
          duracion: Math.round(duracion) + 1,
          empresaFoto: arr[index].empresaFoto,
          empresaId: arr[index].empresaId,
          empresaNombre: arr[index].empresaNombre,
          fechaCreacion: arr[index].fechaCreacion,
          foto: arr[index].foto,
          nivel: arr[index].nivel,
          instructorFoto: arr[index].instructorFoto,
          instructorId: arr[index].instructorId,
          instructorNombre: arr[index].instructorNombre,
          porcentajeDescuento: arr[index].porcentajeDescuento,
          precioFinal: arr[index].precioFinal,
          precioOriginal: arr[index].precioOriginal,
          publicado: arr[index].publicado,
          titulo: arr[index].titulo,
          resumen: arr[index].resumen,
          valoracion: 0,
        }
        let valoracion = 0;
        const ref = this.afs.collection("cursosValoraciones").doc(curso.id).ref.get();
        await ref.then(doc => {
          if (doc.exists) {
            const valoraciones = doc.data();
            let arrVal = []
            Object.keys(valoraciones).map(function (key) {
              arrVal.push(valoraciones[key])
              return arrVal;
            });
            for (let index = 0; index < arrVal.length; index++) {
              const element = arrVal[index].valoracion.global;
              valoracion += element;
            }
            curso.valoracion = valoracion/arrVal.length
            arreglo.push(curso)
          } else {
            curso.valoracion = 0;
            arreglo.push(curso)
          }
        }).catch(error => console.log(error));
      }
      this.cursos = arreglo;
      this.cursos = this.cursos.filter(t => t.publicado == true);
      this.ordenarCategorias();
      this.filteredCursos = this.cursos;
      this.loaded = 1;
      if (this.shared.getData()) {
        const data = this.shared.getData();
        this.shared.pushData(null)
        if (data.categoria) {
          const index = this.categorias.indexOf(data.categoria)
          this.seleccionCategorias.push(this.categorias[index]);
          this.filtrar()
        }
        if (data.textoBusqueda) {
          this.textoBusqueda = data.textoBusqueda;
          this.filtrar();
        }
        if (data.tipoBusqueda) {
          this.tipoBusqueda = data.tipoBusqueda;
          this.filtrar()
        }
      }
      this.filtrar();
    })
  }

  async cargarInstructores() {
    this.afs.doc("global/indiceInstructores").get().subscribe(snap => {
      const instructores = snap.data();
      let arr = []
      Object.keys(instructores).map(function (key) {
        arr.push(instructores[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        const instructor: instructor = {
          categorias: arr[index].categorias,
          cantCursos: arr[index].cantCursos,
          descripcion: arr[index].descripcion,
          fechaCreacion: arr[index].fechaCreacion,
          foto: arr[index].foto,
          id: arr[index].id,
          empresaId: arr[index].empresaId,
          nombre: arr[index].nombre,
          empresaNombre: arr[index].empresaNombre,
          publicado: arr[index].publicado,
          cantVentas: arr[index].cantVentas,
          resumen: arr[index].resumen,
        }
        arreglo.push(instructor);
      }
      this.instructores = arreglo;
      this.instructores = this.instructores.filter(t => t.publicado == true);
      this.filteredInstructores = this.instructores;
    })
  }

  async cargarEmpresas() {
    this.afs.doc("global/indiceEmpresas").get().subscribe(snap => {
      const empresas = snap.data();
      let arr = []
      Object.keys(empresas).map(function (key) {
        arr.push(empresas[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        const empresa: empresa = {
          categorias: arr[index].categorias,
          cantCursos: arr[index].cantCursos,
          fechaCreacion: arr[index].fechaCreacion,
          foto: arr[index].foto,
          id: arr[index].id,
          cantInstructores: arr[index].cantInstructores,
          nombre: arr[index].nombre,
          publicado: arr[index].publicado,
          descripcion: arr[index].descripcion,
          cantVentas: arr[index].cantVentas,
          resumen: arr[index].resumen,
        }
        arreglo.push(empresa)
      }
      this.empresas = arreglo;
      this.empresas = this.empresas.filter(t => t.publicado == true);
      this.filteredEmpresas = this.empresas;
    })
  }

  async cargarCategorias() {
    const doc = await this.afs.collection("global").doc("global").ref.get()
    const data = doc.data();
    this.categorias = data["categoria"];
  }

  async ordenarCategorias() {
    this.categorias.forEach(categoria => {
      const catCont: categoriaContada = {
        categoria: categoria,
        cant: 0
      }
      this.cursos.forEach(curso => {
        if (curso.categoria == catCont.categoria) {
          catCont.cant += 1;
        }
      })
      this.categoriasContadas = this.categoriasContadas.concat(catCont)
    })
    this.categoriasContadas.sort((a, b) =>+b.cant - +a.cant)
  }
}
